export function isLetter(l: TRenderedSquareState): boolean {
	return l !== "#" && l !== "";
}
